// extracted by mini-css-extract-plugin
module.exports = {"moneyButton":"_009864b","playMoney":"_3d2d812","realMoney":"_ea06045","popper":"_b2e05ff","arrow":"_666fefa","active":"_9c26932","textColor":"_064c0fd"};